import { UtensilsCrossed } from "lucide-react";

export function BrandLogo({ className = "", size = "md", tone = "light" }) {
  const sz = { sm: "text-lg", md: "text-xl", lg: "text-3xl" }[size];
  const color = tone === "dark" ? "text-emerald-400" : "text-orange-600";
  return (
    <div className={`inline-flex items-center gap-2 font-display font-extrabold ${sz} ${className}`} data-testid="brand-logo">
      <span className={`inline-flex h-9 w-9 items-center justify-center rounded-xl bg-orange-600 text-white shadow-sm ${tone === "dark" ? "bg-emerald-500" : ""}`}>
        <UtensilsCrossed className="h-5 w-5" />
      </span>
      <span className={tone === "dark" ? "text-white" : "text-stone-900"}>
        Portal<span className={color}>Gestão</span>
      </span>
    </div>
  );
}
